const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11.71mm",
    height: "13.229mm",
    viewBox: "0 0 11.71 13.229",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.866 -29.983)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.223 30.303c-0.14811 2e-3 -0.29825 0.03632-0.44023 0.10688l-5.0325 2.5012c-0.50483 0.25089-0.70964 0.85926-0.45875 1.3641l3.2314 6.5014v-8.52c0-0.56373 0.45377-1.0175 1.0175-1.0175h2.7906l-0.18414-0.37092c-0.18033-0.36284-0.54535-0.57015-0.92385-0.5651zm4.9547 8.6819v0.78099c0.10094-0.24237 0.10762-0.5224 0-0.78099zm-6.9358 3.2377 0.05238 0.10582c0.25089 0.50483 0.85926 0.70911 1.3641 0.45822l1.0445-0.51907h-2.1625c-0.104 0-0.20406-0.01624-0.29843-0.04498z",
    strokeWidth: 0.63995,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.523,
    y: 31.239,
    width: 7.6547,
    height: 11.028,
    ry: 1.0176,
    strokeWidth: 0.63995,
    style: {
      paintOrder: "stroke fill markers"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.8c97c358e25ee405f6a66743b3d8a021.svg";
export { ForwardRef as ReactComponent };